import { filterEventHandler } from './itemlist';
import { KEYCODES } from './util/keycodes';


/**
 * Simple autocomplete facet filter plugin.
 */
const cache = {};

$.fn.autocomplete = function(callback) {
  $('[data-autocomplete]', this).each(function() {
    console.info('Initializing an autocomplete element!');

    const $input = $(this);
    const defaults = {
      blurOnSelect: true,
      showOnEmpty: true,
      emptyOnFocus: true,
      emptyOnBlur: true,
      nested: false,
    };
    let options = $input.data('autocomplete') || {};

    if (typeof options === 'string') {
      options = {
        url: options,
      };
    }
    options = Object.assign({}, defaults, options);

    const placeholder = $input.attr('placeholder');
    const $toggle = $input.parent().find('[data-autocomplete-toggle]');

    const name = $input.attr('name');
    if (!options.named) {
      $input.removeAttr('name');
    }

    const extraTarget = options.extraTarget ? $input.closest('form').find(options.extraTarget) : null;
    let $select;
    if (options.autocomplete) {
      $select = $input.closest('form').find(options.autocomplete);
    } else {
      $select = $input.parent().find('.autocomplete');
    }
    let $noresults = $input.parent().find('.autocomplete__choice--no-result');
    if (!$select.length) {
      $select = $('<div class="autocomplete" data-autocomplete-results></div>');

      $(`#${$input.data('list')} option`).each(function (index) {
        const $choice = $(`
          <label class="autocomplete__choice" data-source-index="${index}">
            <div class="autocomplete__choice-label">
              <input type="checkbox" ${this.selected ? 'checked' : ''} style="${$(this).data('style')}">
              <span>${this.innerText}</span>
            </div>
          </label>
        `);
        if ($(this).data('count') !== undefined) {
          $choice.find('> .autocomplete__choice-label').append($(`<span class="hint">${$(this).data('count')}</span>`));
        }
        $choice.data('value', this.value);
        $choice.data('display', this.innerText);
        if (this.disabled) {
          $choice.addClass('disabled');
        }
        $select.append($choice);
      });
      $input.after($select);
    }

    if (!$noresults.length && $input.data('no-results')) {
      $noresults = $(`
        <label class="autocomplete__choice autocomplete__choice--no-result disabled">
          ${$input.data('no-results')}
        </label>
      `);
      $noresults.hide();
      $select.append($noresults);
    }

    $select.on('mouseenter', '.autocomplete__choice,.autocomplete__entry', function() {
      $select.find('.active').removeClass('active');
      $(this).addClass('active');
    });

    $select.on('mouseleave', '.autocomplete__choice,.autocomplete__entry', function() {
      $(this).removeClass('active');
    });

    $select.on('click', '.autocomplete__choice,.autocomplete__entry', (event) => {
      event.preventDefault();
      $input.focus();
    });

    $select.on('mousedown', '.autocomplete__choice-toggle', function(event) {
      event.preventDefault();
      event.stopPropagation();
      $(this).parent().parent().toggleClass('autocomplete__choice--open');
    });

    $select.closest('.autocomplete-container').on('click', '> label > div > input', function(event) {
      event.preventDefault();
      event.stopPropagation();
      const index = $(this).parent().parent().attr('data-index');
      $select.find(`.autocomplete__choice[data-source-index="${index}"] input`)[0].checked = false;
      $(this).parent().parent().remove();
      if (callback) {
        callback.call($input);
      }
    });

    $select.on('mousedown', '[data-autocomplete-value]', function() {
      $select.html('').hide();
      $input.val($(this).attr('data-autocomplete-value'));
      if (options.form) {
        $input.closest('form').submit();
      } else if (options.blurOnSelect) {
        $input.trigger('blur');
      }
      if (extraTarget) {
        extraTarget.val($(this).attr('data-autocomplete-extra-value') || '').trigger('change');
        setTimeout(() => {
          extraTarget.focus();
        }, 0);
      }
    });

    $select.on('mousedown', '.autocomplete__choice-label', function(event) {
      const $choice = $(this).parent();
      if ($choice.is('.disabled')) {
        return;
      }
      const cb = $choice.find('input')[0];
      if (cb.checked) {
        $select
          .closest('.autocomplete-container')
          .find(`input[value="${$choice.data('value')}"]`)
          .parent()
          .parent()
          .remove();

        if (options.closeAfterSelect) {
          $input.blur();
        }
      } else {
        $choice
          .parents('.autocomplete__choice')
          .find('> .autocomplete__choice-label > input:checked')
          .each(function() {
            this.checked = false;
            $select
              .closest('.autocomplete-container')
              .find(`input[value="${$(this).parent().parent().data('value')}"]`)
              .parent()
              .parent()
              .remove();
          });
        $choice
          .find('.autocomplete__choice > .autocomplete__choice-label > input:checked')
          .each(function() {
            this.checked = false;
            $select
              .closest('.autocomplete-container')
              .find(`input[value="${$(this).parent().parent().data('value')}"]`)
              .parent()
              .parent()
              .remove();
          });
        const $inputDiv = $choice.clone();
        $inputDiv
          .removeAttr('for')
          .removeClass('autocomplete__choice')
          .removeClass('autocomplete__choice--level-1')
          .removeClass('autocomplete__choice--level-2')
          .removeClass('autocomplete__choice--level-3');
        $inputDiv.find('.autocomplete__children').remove();
        $inputDiv.find('.autocomplete__choice-toggle').remove();
        $inputDiv.find('input').attr('name', name).val($choice.data('value')).get(0).checked = true;
        let $afterInput = null;
        let currentIndex = parseInt($inputDiv.data('source-index'), 10);
        if (Number.isNaN(currentIndex)) {
          currentIndex = $inputDiv.data('source-index');
        }
        $inputDiv.removeAttr('data-source-index').attr('data-index', currentIndex);
        $select.closest('.autocomplete-container').find('[data-index]').each(function() {
          let index = parseInt($(this).data('index'), 10);
          if (Number.isNaN(index)) {
            index = $(this).data('index');
          }
          if (index < currentIndex) {
            $afterInput = $(this);
          }
        });
        if ($afterInput) {
          $inputDiv.insertAfter($afterInput);
        } else {
          $afterInput = $select.closest('.autocomplete-container').find('[data-index]:first');
          if ($afterInput && $afterInput.length) {
            $inputDiv.insertBefore($afterInput);
          } else {
            $select.closest('.autocomplete-container').append($inputDiv);
          }
        }

        const labels = [$choice.find('> .autocomplete__choice-label span').text()];
        $choice.parents('.autocomplete__choice').each(function() {
          labels.push($('<i class="icon icon-chevron-right" />'));
          labels.push($(this).find('> .autocomplete__choice-label span').text());
        });

        $inputDiv.find('> .autocomplete__choice-label span:first').html(labels.reverse());

        if (options.closeAfterSelect) {
          $input.blur();
        }
      }
      cb.checked = !cb.checked;
      if (callback) {
        callback.call(this, event);
      }
    });

    $select.hover(
      () => {
        $select.addClass('hover');
      },
      () => {
        $select.removeClass('hover');
      },
    );

    function escapeRegExp(str) {
      return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
    }

    if (!options.url && !$input.attr('data-autocomplete-url')) {
      $input.on('input', function () {
        let pattern = escapeRegExp(this.value);
        if (options.matchFront) {
          pattern = `(\\s|^)${pattern}`;
        }
        const search = new RegExp(pattern, 'i');
        $select.find('label').each(function () {
          const $choice = $(this);
          const display = $choice.data('display');

          if (search.test(display)) {
            $choice.show();
          } else {
            $choice.hide();
          }
        });
        if ($select.find('.autocomplete__choice.active:visible').length === 0) {
          $select.find('.autocomplete__choice.active').removeClass('active');
          $select.find('.autocomplete__choice:visible:first').addClass('active');
        }
        if ($select.find('label:visible').length) {
          $noresults.hide();
        } else {
          $noresults.show();
        }
      });
    } else {
      const url = options.url || $input.attr('data-autocomplete-url');
      $input.on('input', function () {
        const q = this.value.trim();
        if (q) {
          const data = { q };
          if (options.extraUrlField) {
            const extraUrlField = $input.closest('form').find(options.extraUrlField);
            if (extraUrlField) {
              data[options.extraUrlFieldName || extraUrlField.attr('name')] = extraUrlField.val();
            }
          }
          const cacheKey = $.param(data);
          if (cache[cacheKey] !== undefined) {
            if (cache[cacheKey]) {
              $select.html(cache[cacheKey]).show();
            } else {
              $select.html('').hide();
            }
          } else {
            $.ajax({
              url,
              data,
              method: 'GET',
            }).then((result) => {
              cache[cacheKey] = result.trim();
              if (q === this.value.trim()) {
                if (cache[cacheKey]) {
                  $select.html(cache[cacheKey]).show();
                } else {
                  $select.html('').hide();
                }
              }
            });
          }
        } else {
          $select.html('').hide();
        }
      });
    }

    $input.on('keydown', (event) => {
      let behaviour = 'nearest';
      let $active = $select.find('.autocomplete__choice.active,.autocomplete__entry.active');

      switch (event.which) {
        case KEYCODES.RIGHT:
          if (options.nested) {
            event.preventDefault();
            if ($active.hasClass('autocomplete__choice--has-children')) {
              if ($active.hasClass('autocomplete__choice--open')) {
                $active = $active.removeClass('active').find('.autocomplete__choice:visible:first').addClass('active');
              } else {
                $active.addClass('autocomplete__choice--open');
              }
            }
          }
          break;
        case KEYCODES.LEFT:
          if (options.nested) {
            event.preventDefault();
            if ($active.hasClass('autocomplete__choice--has-children')) {
              if ($active.hasClass('autocomplete__choice--open')) {
                $active.removeClass('autocomplete__choice--open');
              } else if ($active.parent().closest('.autocomplete__choice').length) {
                $active = $active.removeClass('active').parent().closest('.autocomplete__choice').addClass('active');
              }
            } else if ($active.parent().closest('.autocomplete__choice').length) {
              $active = $active.removeClass('active').parent().closest('.autocomplete__choice').addClass('active');
            }
          }
          break;
        case KEYCODES.DOWN:
          event.preventDefault();
          if ($active.length) {
            behaviour = 'end';
            const choices = $select.find('.autocomplete__choice:visible,.autocomplete__entry:visible');
            const l = choices.length;
            let i = 0;
            for (; i < l; i += 1) {
              if (choices[i] === $active[0]) {
                break;
              }
            }
            if (i < l - 1) {
              $active.removeClass('active');
              $active = choices.eq(i + 1).addClass('active');
            }
          } else {
            $active = $select.find('.autocomplete__choice:visible:first,.autocomplete__entry:visible:first')
              .addClass('active');
          }
          break;
        case KEYCODES.UP:
          event.preventDefault();
          if ($active.length) {
            const choices = $select.find('.autocomplete__choice:visible,.autocomplete__entry:visible');
            const l = choices.length;
            let i = 0;
            for (; i < l; i += 1) {
              if (choices[i] === $active[0]) {
                break;
              }
            }
            if (i > 0) {
              $active.removeClass('active');
              $active = choices.eq(i - 1).addClass('active');
            }
          } else {
            $active = $select.find('.autocomplete__choice:visible:last,.autocomplete__entry:visible:last')
              .addClass('active');
          }
          break;
        case KEYCODES.ENTER:
          event.preventDefault();
          event.stopPropagation();
          if ($active.is('[data-autocomplete-value]')) {
            $active.trigger('mousedown');
          } else {
            $active.find('> .autocomplete__choice-label').trigger('mousedown');
          }
          break;
        case KEYCODES.ESCAPE:
          $input.val('').trigger('input');
          break;
        default:
          break;
      }

      setTimeout(() => {
        if ($active.length && $select[0].scrollHeight > $select.height() + 10) {
          $active.find('> .autocomplete__choice-label')[0].scrollIntoView({
            behavior: 'instant',
            block: behaviour,
            inline: 'nearest',
          });
        }
      }, 10);
    });

    $input.on('focus click', () => {
      if (options.showOnEmpty || ($input.val() && $select.html())) {
        $select.show();
      }
      if (options.emptyOnFocus) {
        $input.val('').attr('placeholder', '');
      }
      $input.parent().addClass('focus');
    });

    $input.on('blur', () => {
      if (!$select.hasClass('hover') || options.closeAfterSelect) {
        $select.hide();
        if (options.emptyOnBlur) {
          $input.val('').attr('placeholder', placeholder);
        }
        $input.parent().removeClass('focus');
      }
    });

    $toggle.on('mousedown', (event) => {
      event.preventDefault();
      $input[$input.parent().hasClass('focus') ? 'blur' : 'focus']();
    });
  });
  return this;
};

$(() => {
  $(document).autocomplete(filterEventHandler);
});
